import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import LinearProgress from "@material-ui/core/LinearProgress";
import TextField from "@material-ui/core/TextField";
import AssessmentIcon from "@material-ui/icons/Assessment";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import green from "@material-ui/core/colors/green";
import { useHistory } from "../../../shared/hooks/useHistory";

import { asyncSendWelcomeEmail } from "../../actions/resend-welcome-email.actions";
import {
  resetRequest,
  setClose,
} from "../../../shared/request/actions/requestActions";

import { validateEmail } from "../../../shared/validateEmail";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  success: {
    color: green[500],
  },
  messageNote: {
    color: "#a3afb7",
    fontSize: theme.spacing(1.5),
    display: "flex",
    marginTop: "10px",
  },
  clickHereText: {
    color: "#76838f",
    cursor: "pointer",
    fontWeight: "bold",
  },
}));

export const ResendWelcomeEmailPage = () => {
  const history = useHistory();
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [emailValid, setEmailValid] = useState({
    isError: false,
    message: "",
  });
  const dispatch = useDispatch();
  const request = useSelector((state) => state.request.request);

  useEffect(() => {
    dispatch(resetRequest());
  }, [dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const isEmailEmpty = !email.length;
    const isEmailInvalid = !validateEmail(email);

    if (isEmailEmpty || isEmailInvalid) {
      setEmailValid({
        isError: true,
        message: isEmailEmpty
          ? "The email is required"
          : "The email is not correct",
      });
      return;
    }

    setEmailValid({ isError: false, message: "" });
    dispatch(asyncSendWelcomeEmail(email));
  };

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleClose = () => {
    dispatch(setClose());
  };

  const handleCancelButton = () => {
    dispatch(resetRequest());
    history.goBack();
  };
  const isSuccess = request.type === "success";

  const redirectToRecoverAssessmentAccess = () => {
    history.push("/send-verify-code");
  };

  return (
    <Container component="main" maxWidth="xs">
      {request.isFetching && (
        <div className={classes.root}>
          <LinearProgress color="secondary" />
        </div>
      )}
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <AssessmentIcon />
        </Avatar>

        {isSuccess && (
          <>
            <Typography component="h1" variant="h6" className={classes.success}>
              Welcome Email Sent.
            </Typography>
            <Typography component="h1" variant="h6" className={classes.success}>
              Please check your email
            </Typography>
          </>
        )}

        <form className={classes.form} noValidate onSubmit={handleSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="username"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={handleChange}
            error={emailValid.isError}
            helperText={emailValid.message}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            disabled={request.isFetching}
          >
            Send Welcome Email
          </Button>

          <Button fullWidth onClick={handleCancelButton}>
            Cancel
          </Button>
        </form>

        {isSuccess && (
          <Typography
            component="h1"
            variant="body1"
            className={classes.messageNote}
          >
            If you haven&apos;t received your email yet. Please click&nbsp;
            <span
              role="button"
              className={classes.clickHereText}
              onClick={redirectToRecoverAssessmentAccess}
              onKeyDown={(f) => f}
              tabIndex={0}
            >
              here
            </span>
            .
          </Typography>
        )}
      </div>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={request.isOpen}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={request.type !== "success" ? "warning" : "success"}
        >
          {request.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};
